/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react'
import PropTypes from 'prop-types'
import {Box, Text} from '@chakra-ui/react'
import {InfoIcon} from '../icons'
import {FormattedMessage} from 'react-intl'
import {InfoIconTooltip} from '../info-icon-tooltip'

/**
 * This component renders a small info icon and displays a popover when hovered. It could be adapted
 * to handle any kind of popover if needed, but for now its been set up to be used/shared for displaying
 * promotions applied to products and/or orders on cart, checkout, order confirmation and order history.
 */
const PromoPopover = ({header, children, ...props}) => {
    return (
        <Box display="inline-flex" position="relative" {...props}>
            <InfoIconTooltip
                name="promo-popover"
                helpText={
                    <>
                        <Text paddingBlockEnd={2.5} textStyle="Semi Bold Medium">
                            {header || (
                                <FormattedMessage
                                    defaultMessage="Promotions Applied"
                                    id="promo_popover.heading.promo_applied"
                                />
                            )}
                        </Text>
                        {children}
                    </>
                }
                icon={InfoIcon}
                iconProps={{
                    boxSize: '18px',
                    mt: '-2px',
                    ml: '-1px',
                    color: 'gray.600',
                    // reset the theme tooltop variant mx value
                    mx: null
                }}
                variant="promoPopover"
            />
        </Box>
    )
}

PromoPopover.propTypes = {
    header: PropTypes.any,
    children: PropTypes.any
}

export default PromoPopover
